module.exports = __webpack_public_path__ + "img/anquan_zhongji.938f07b6.png";